<template>
  <v-container fluid>
    <template>
      <v-row>
        <v-col cols="6" class="pb-1 pt-0">
          <v-breadcrumbs :items="itemsBreadcrumbs" class="pl-0 pt-0 pb-1">
            <template v-slot:item="{ item }">
              <v-breadcrumbs-item :href="item.href" :disabled="item.disabled">
                {{ item.text.toUpperCase() }}
              </v-breadcrumbs-item>
            </template>
          </v-breadcrumbs>
        </v-col>
        <v-col cols="6" class="pb-1 pt-0 h-100">
          <office-login></office-login>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="10" class="pt-1">
          <span class="headline font-weight-medium">Médicos </span>
        </v-col>
        <v-col cols="2" class="pt-1">
          <v-btn
            v-if="this.$hasPermision('doctores.create')"
            dark
            color="#023145"
            width="140"
            class="float-right"
            @click="handleShowCreate"
          >
            Nuevo
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4" class="pt-1">
          <v-text-field
            v-model="search_doctors"
            label="Buscar"
            hide-details
            prepend-inner-icon="mdi-magnify"
            solo
            @keydown="handleInputSearchByEnter"
          >
          </v-text-field>
        </v-col>
        <v-col cols="5" class="pt-1">
          <v-btn class="w-btn-search" height="40" @click="handleSearch">
            Buscar
          </v-btn>
        </v-col>
        <v-col cols="1" class="pt-1 ">
          <v-btn
            dark
            class="float-left ml-1"
            color="green"
            @click="handleImport"
          >
            Importar
          </v-btn>
        </v-col>
        <v-col cols="2" class="pt-1">
          <v-btn
            v-if="this.$hasPermision('doctores.filters')"
            dark
            color="#023145"
            outlined
            width="140"
            class="float-right"
            @click="handleShowFilters"
          >
            <v-icon class="mr-2" size="14">fas fa-sort-amount-down</v-icon>
            Ver Filtros
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-data-table
              v-model="selectedRows"
              :headers="headers"
              :items="doctors"
              :items-per-page="10"
              class="elevation-1 w-table"
              height="57vh"
              show-select
              :single-select="true"
              @item-selected="handleSelectItem"
              :loading="loading"
              loading-text="Cargando datos ... "
              :options.sync="options"
              :server-items-length="paginated.total"
            >
              <template v-slot:top>
                <span
                  class="ml-3 pt-3 pb-3 subtitle-1 font-weight-bold w-title-table"
                >
                  Todos los médicos
                </span>
                <v-divider></v-divider>
              </template>

              <template v-slot:item.fullname="{ item }">
                <!-- <span>{{ item.fullname }}</span> -->
                <span>{{ item.surname + " " + item.name }}</span>
                <span v-if="item.active" class="activo">
                  <v-icon size="11" color="#4CAF50">fas fa-check</v-icon>
                  activo
                </span>
                <span v-else class="inactivo">
                  <v-icon size="11" color="#F44336">fas fa-minus</v-icon>
                  inactivo
                </span>
                <br />
                <v-icon v-if="item.email" class="mr-1" size="13" color="#303197"
                  >fas fa-envelope</v-icon
                >
                <span>{{ item.email }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </template>

    <div class="text-center">
      <v-bottom-sheet
        v-model="show_options_crud"
        :hide-overlay="true"
        persistent
        :retain-focus="false"
      >
        <v-sheet class="text-center" height="85px">
          <div class="py-3">
            <v-btn
              v-if="this.$hasPermision('doctores.edit')"
              class="mt-3"
              dark
              color="blue"
              outlined
              @click="handleEdit"
            >
              <v-icon class="mr-2" size="16">fas fa-pen</v-icon>
              Editar
            </v-btn>
            <v-btn
              v-if="
                show_btn_active && this.$hasPermision('doctores.change_status')
              "
              class="ml-4 mt-3"
              dark
              color="green"
              outlined
              @click="handleChangeStatus"
            >
              <v-icon class="mr-2" size="16">far fa-check-circle</v-icon>
              Activar
            </v-btn>
            <v-btn
              v-if="
                !show_btn_active && this.$hasPermision('doctores.change_status')
              "
              class="ml-4 mt-3"
              dark
              color="amber"
              outlined
              @click="handleChangeStatus"
            >
              <v-icon class="mr-2" size="16">fas fa-minus-circle</v-icon>
              Inactivar
            </v-btn>
            <v-btn
              v-if="this.$hasPermision('doctores.destroy')"
              class="ml-4 mt-3"
              dark
              color="red"
              outlined
              @click="handleDelete"
            >
              <v-icon class="mr-2" size="16">fas fa-times-circle</v-icon>
              Eliminar
            </v-btn>
          </div>
        </v-sheet>
      </v-bottom-sheet>
    </div>
    <create-update ref="createUpdate"></create-update>
    <Filters ref="filters"></Filters>
    <upload ref="upload"></upload>
    <form-download ref="formDownload"></form-download>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import OfficeLogin from "../../../components/auth/OfficeLogin";
import ArrayTools from "../../../helpers/ArrayTools";
import CreateUpdate from "../../../components/doctors/CreateUpdate";
import Filters from "../../../components/doctors/Filters";
import FormDownload from "../../../components/customers/FormDownload";
import Upload from "../../../components/doctors/Upload";

export default {
  name: "Doctores",
  components: {
    CreateUpdate,
    Filters,
    OfficeLogin,
    FormDownload,
    Upload,
  },
  data() {
    return {
      search_doctors: null,
      drawer: false,
      show_options_crud: false,
      show_btn_active: false,
      selectedRows: [],
      itemsBreadcrumbs: [
        {
          text: "Ventas",
          disabled: true,
          href: "",
        },
      ],
      headers: [
        { text: "MÉDICO", value: "fullname", width: 450 },
        { text: "CMC", value: "code", width: 140 },
        { text: "DOCUMENTO", value: "document", width: 140 },
        { text: "TELÉFONO", value: "phone", width: 120 },
        { text: "COMISIÓN", value: "commission" },
        { text: "ESPECIALIDAD", value: "specialty_name" },
      ],
      loading: false,
      options: {},
      dataTable: { page: 1 },
      pageSelected: 1,
      perPage: 10,
    };
  },
  watch: {
    options: {
      handler() {
        this.loading = true;
        this.perPage = this.options.itemsPerPage;
        this.pageSelected = this.options.page;
        this.getDoctors({
          paginated: true,
          page: this.pageSelected,
          itemsPerPage: this.perPage,
        })
          .then((res) => (this.loading = false))
          .catch((err) => (this.loading = false));
      },
      deep: true,
    },
  },
  computed: {
    ...mapState("doctors", ["doctors", "paginated"]),
  },
  methods: {
    ...mapActions("zonas", ["getZonas"]),
    ...mapActions("documents", ["getTypesDocuments"]),
    ...mapActions("doctors", ["getDoctors", "change_status", "delete"]),
    ...mapActions("specialty", ["getSpecialtys"]),
    showOptionCrud() {
      this.show_options_crud = this.selectedRows.length > 0;
      if (this.show_options_crud) {
        this.show_btn_active = !this.selectedRows[0].active;
      }
    },
    handleSelectItem(selected) {
      if (selected.value) {
        this.selectedRows.push(selected.item);
      } else {
        let index_found = ArrayTools.getIndexById(
          this.selectedRows,
          selected.item.id
        );
        if (index_found > -1) {
          this.selectedRows.splice(index_found, 1);
        }
      }
      this.showOptionCrud();
    },
    handleShowCreate() {
      this.$refs.createUpdate.showForm("Nuevo Médico", "create");
    },
    handleEdit() {
      let doctor = this.selectedRows[0];
      this.selectedRows = [];
      this.showOptionCrud();
      this.$refs.createUpdate.showForm(
        "Modificar datos de médico",
        "update",
        doctor
      );
    },
    handleShowFilters() {
      this.$refs.filters.showForm("Filtrar datos de médico");
    },
    async getAllDoctors() {
      await this.getDoctors();
    },
    handleInputSearchByEnter(KeyboardEvent) {
      if (KeyboardEvent.code == "Enter") {
        this.handleSearch();
      }
    },
    async handleSearch() {
      this.loading = true;
      this.selectedRows = [];
      this.showOptionCrud();
      let filters = {};
      if (this.search_doctors) {
        if (!isNaN(this.search_doctors)) {
          filters = { ...filters, document: this.search_doctors };
        } else {
          filters = { ...filters, fullname: this.search_doctors };
        }
      }
      await this.getDoctors(filters);
      this.loading = false;
    },
    async handleChangeStatus() {
      let doctor = this.selectedRows[0];
      this.selectedRows = [];
      this.showOptionCrud();
      await this.change_status(doctor);
    },
    async handleDelete() {
      let doctor = this.selectedRows[0];
      await this.delete(doctor);
      this.selectedRows = [];
      this.showOptionCrud();
    },
    handleDownload() {
      this.$refs.formDownload.showForm();
    },
    async handleImport() {
      this.$refs.upload.show();
    },
  },
  created() {
    this.getTypesDocuments();
    this.getZonas();
    this.getSpecialtys();
  },
};
</script>

<style scoped></style>
